module.exports = __webpack_public_path__ + "images/Alain_Brunetti-d3a351072d654703f05c9126433221cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Alain_Brunetti.png
// module id = 27
// module chunks = 0